export const login = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        login:'Sign In',
		forgetpassword:'I forgot my password?',
		token_expiry:'Session expired. Please login to continue',
		copyrightInfo: '2025 © Tata Communications Ltd. All rights reserved.'
    },
	ar: {
        login:'تسجيل الدخول',
		forgetpassword:'لقد نسيت كلمة المرور؟',
		token_expiry:'انتهت الجلسة. الرجاء تسجيل الدخول للمتابعة',
		copyrightInfo: '٢٠٢٥ © تاتا كوميونيكيشنز المحدودة. جميع الحقوق محفوظة.'
    }
}
